<template>
  <div class="tpassDetail">
    <loading :show="apiLoading"></loading>
    <div class="loading" v-if="isShowMsg === null"></div>
    <!-- 情境1-1 查詢收據明細 -->
    <div class="d-lg-none tpass-detail-container" v-if="isShowMsg === false">
      <!-- 收據明細 -->
      <tPass-detail-content
        :TPassdetailData="detailData[0]"
        :isShowDetailsAll="isShowDetailsAll"
      ></tPass-detail-content>
      <!-- 個資聲明 -->
      <personal-info
        v-if="!isShowDetailsAll"
        @changeMsg="changeMsg"
        :reqData="detailData[0]"
        :token="token"
      ></personal-info>
    </div>
    <!-- 提示視窗 -->
    <div class="modal-alert" v-if="isShowMsg || this.detailData[0].rpStatus === '9'">
      <t-pass-msg
        ref="tPassMsg"
        @openTPassDetailContent="openTPassDetailContent"
        :TPassdetailData="detailData[0]"
      ></t-pass-msg>
    </div>
  </div>
</template>

<script>
import CommonApiMixin from '@/mixins/commonApi';
import ApiMixin from '@/mixins/api';

export default {
  name: 'TpassDetail',

  mixins: [CommonApiMixin, ApiMixin],

  data() {
    return {
      // 收據
      detailData: [
        {
          rpStatus: '1',
        },
      ],
      // QueryFNTSF input object
      reqData: {},
      // loading switch
      apiLoading: false,
      // 接收 url token key
      token: null,
      // 收據頁為false 訊息頁為true
      isShowMsg: null,
      // 同意 switch
      agreement: false,
      // 收據明細全部顯示 switch
      isShowDetailsAll: false,
    };
  },

  created() {
    $('#app, html').css('background-color', '#fff');
    $('#app').css('background-image', 'none');
    $('#app').css('padding-top', '0px');
    $('#global-navbar').css('display', 'none');
    this.token = this.$route.query.token;
    // 開發機
    // this.reqData.rpPublicNo = 'ZZ1100032315';
    // this.reqData.rpPublicRandomCode = '4230';
    // 測試機
    // this.reqData.rpPublicNo = 'ZZ1100000471';
    // this.reqData.rpPublicRandomCode = '2966';
    this.reqData.rpPublicNo = this.$route.query.rpPublicNo;
    this.reqData.rpPublicRandomCode = this.$route.query.rpPublicRandomCode;
    this.QrgetData(this.reqData);
  },

  methods: {
    // 查詢收據
    QrgetData(data) {
      this.$store.commit('api/start');
      this.$bvModal.hide('modal-alert');
      this.apiLoading = true;
      const url = '/GovEReceipt/FrontDeskService/QueryFNTSF';
      const method = 'post';
      this.axiosServiceSend(data, url, method, 'QrgetData');
    },

    closeWindow() {
      // console.log('closeWindow');
      // window.close();
      // setTimeout(() => {
      //   window.opener = null;
      //   window.open('about:blank', '_top').close();
      //   //   window.location.href = 'about:blank';
      //   // window.close();
      // }, 1);
      const tempHerf = `${window.location.href.substr(
        0,
        window.location.href.indexOf('#')
      )}#/B?ID=1&form=true`;
      window.location.href = tempHerf;
      // window.open('about:blank', '_top').close();
    },

    // 換訊息
    changeMsg(type, message, subMessage, title, options) {
      this.isShowMsg = true;
      this.$nextTick(() => {
        this.$refs.tPassMsg.changeMsgIcon(type, message, subMessage, title, options);
      });
    },
    // 已歸戶收據 開內頁明細
    openTPassDetailContent(item, type) {
      console.log('item', item);
      console.log('type', type);
      this.TPassdetailData = item;
      this.isShowMsg = false;
      this.isShowDetailsAll = true;
    },

    success(type, result) {
      this.isShow = true;
      switch (type) {
        case 'QrgetData':
          console.log('QrgetData', result);
          if (result.data.object[0].rpStatus === '9') {
            this.changeMsg('info', '', '此收據已作廢', '');
          } else if (result.data.object[0].rpStatus === '1') {
            this.isShowMsg = false;
          } else {
            this.changeMsg('info', `查無收據號碼：${this.reqData.rpPublicNo}`, '', '查無此收據');
          }
          this.detailData = result.data.object;
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          break;
        default:
          break;
      }
      console.log('有資料');
    },
    fail(type, error) {
      switch (type) {
        case 'QrgetData':
          console.log(error);
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
  },
  fail(type, error) {
    console.log('error', error);
    this.showApiMessage('error', `error${error}`, '訊息');
  },
};
</script>
